import clsx from 'clsx'
import React, { useCallback, useEffect } from 'react'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Spinner } from '@wartek-id/spinner'

import { Header } from 'components/Header'
import { useQueryApiGetKSSelectionResult } from 'api/bcks/useAPIBCKSInvitation'
import { formatDate } from 'utils/datetime'
import useKSPSTrackEvent from './hooks/useKSPSTrackEvent'

import ImgHandshake from 'assets/icons/img-handshake.svg'
import ImgAnnouncementSpeaker from 'assets/icons/img-announcement-speaker.svg'

const AnnouncementPage = () => {
  const { data, isLoading } = useQueryApiGetKSSelectionResult()
  const { KSPSTrackEvent } = useKSPSTrackEvent()

  const handleDownloadFile = useCallback(() => {
    const fileName = data.skFileUrl.split('?')[0].split('/').pop()
    const anchor = document.createElement('a')
    anchor.setAttribute('href', data.skFileUrl)
    anchor.setAttribute('download', fileName)
    anchor.setAttribute('target', '_blank')
    anchor.click()
  }, [data])

  useEffect(() => {
    KSPSTrackEvent({
      event_name: data?.isSelected
        ? 'enter_announcement_selected_ks_page'
        : 'enter_announcement_not_selected_ks_page',
      additional_info: data?.isSelected
        ? [
            {
              key: 'npsn',
              value: data.school.name,
            },
          ]
        : [],
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (isLoading) {
    return (
      <div className="relative flex flex-col min-h-screen max-w-xl mx-auto">
        <Header
          title="Pengumuman"
          titlePosition="left"
          variant={'default'}
          backHref="/bcks/invitation/final"
          iconLeftSrc={'/icon/arrow-left.svg'}
          hasBackButton
        />
        <div className="pt-24 px-5 flex justify-center">
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'relative flex flex-col min-h-screen max-w-xl mx-auto',
        data.isSelected && 'bg-[#103178]'
      )}
    >
      <Header
        title="Pengumuman"
        titlePosition="left"
        variant={data.isSelected ? 'milBlue' : 'default'}
        backHref="/bcks/invitation/final"
        iconLeftSrc={
          data.isSelected
            ? '/icon/arrow-left-white.svg'
            : '/icon/arrow-left.svg'
        }
        className={clsx(data.isSelected && 'border-b-0')}
        hasBackButton
      />

      <div className="pt-24 px-5">
        {data.isSelected ? (
          <div className="flex flex-col gap-1 items-center">
            <ImgHandshake width={84} height={84} />

            <Text variant="heading-md" color="inverse" className="text-center">
              Selamat! Anda lolos seleksi untuk menjadi Kepala Sekolah
            </Text>

            <Text
              variant="body-sm"
              color="inverse-subdued"
              className="text-center"
            >
              Pihak Dinas Pendidikan setempat akan menghubungi Anda untuk
              langkah selanjutnya.
            </Text>
          </div>
        ) : (
          <div className="flex flex-col gap-1 items-center">
            <ImgAnnouncementSpeaker width={96} height={96} />
            <Text variant="heading-md" className="text-center">
              Maaf, Anda belum lolos seleksi untuk menjadi Kepala Sekolah
            </Text>

            <Text variant="body-sm" color="subdued" className="text-center">
              Terima kasih atas partisipasi Anda. Tetap semangat, data Anda
              sudah disimpan untuk seleksi periode selanjutnya.
            </Text>
          </div>
        )}

        {data.isSelected && (
          <div className="mt-4 px-[12px] py-[10px] bg-[#ECFEF2] border border-[#4CA375] rounded flex flex-col gap-[6px]">
            <Text variant="body-sm" color="subdued" className="text-center">
              Penempatan
            </Text>
            <Text variant="heading-sm" className="text-center !text-[#2E8A5C]">
              {data.school.name} {data.school.city}
            </Text>
          </div>
        )}

        <div className="mt-4 px-[12px] py-[10px] bg-white border border-[#C9CBCF] rounded flex flex-col gap-[6px]">
          <Text variant="body-sm" color="subdued" className="text-center">
            Nama
          </Text>
          <Text variant="subheading" className="text-center">
            {data.candidate.name}
          </Text>
          <Text variant="body-sm" color="subdued" className="text-center">
            Nomor Induk Pegawai
          </Text>
          <Text variant="subheading" className="text-center">
            {data.candidate.nip}
          </Text>
          <Text variant="body-sm" color="subdued" className="text-center">
            Tanggal Lahir
          </Text>
          <Text variant="subheading" className="text-center">
            {formatDate(data.candidate.dateOfBirth)}
          </Text>
        </div>

        {data.isSelected && (
          <div className="mt-6 flex justify-center">
            <Button onClick={() => handleDownloadFile()}>
              Unduh Surat Keputusan
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default AnnouncementPage
